var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}]},[(_vm.newCalculationOpenSwitch)?_c('NewCheckoutOrder'):_c('OldCheckoutOrder')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }